<template>
    <v-col cols="6" md="4" lg="3" class="text-center py-10 py-lg-40">
        <div class="pb-20 pb-md-34 border-bottom h-100">
            <v-img :src="src" class="w-100 mb-12 mb-lg-24"></v-img>
            <p class="page-text-lg font-weight-medium mb-4 mb-lg-10">
                <slot/>
            </p>
            <p class="page-text color-grey-51">
                {{num}}
            </p>
        </div>
    </v-col>
</template>

<script>

export default{
    props : {
        src : {type :String, default : ""},
        num : {type :String, default : ""},
    },
    components: {
    },
    data: () => {
        return {
        }
    },
	created() {
	},
	// mounted() {
	// 	this.init();
	// },
	// methods : {
	// 	init : function() {
    //         setTimeout(() => {
    //             AOS.init({
    //                 once: false,
    //                 offset: 240,
    //                 duration: 500,
    //                 throttleDelay : 100,
    //                 easing : 'ease-in-out',
    //                 anchorPlacement : 'top-center',
    //             });
    //         }, 100);
	// 	}
	// },
}
</script>

<style scoped>
</style>